import { TileLayer, BitmapLayer, GeoJsonLayer } from 'deck.gl';
import { fromUrl } from 'geotiff';

import * as plotty from "plotty"

const GeotiffURL = "https://storage.googleapis.com/g3-open-resource/MapChallenge2023/north_america/na_landcover1200-epsg4326-lasted.tif"

const colorTable = [
  { r: 0, g: 0, b: 0 , a:0},
  { r: 3, g: 62, b: 0, a: 0 },
  { r: 147, g: 155, b: 113, a: 0 },
  { r: 25, g: 109, b: 18, a: 0 },
  { r: 31, g: 171, b: 1, a: 0 },
  { r: 91, g: 114, b: 92, a: 0 },
  { r: 107, g: 125, b: 44, a: 0 },
  { r: 178, g: 157, b: 41, a: 0 },
  { r: 180, g: 136, b: 51, a: 0 },
  { r: 233, g: 218, b: 93, a: 0 },
  { r: 224, g: 205, b: 136, a: 0 },
  { r: 160, g: 116, b: 81, a: 0 },
  { r: 186, g: 210, b: 146, a: 0 },
  { r: 63, g: 137, b: 112, a: 0 },
  { r: 108, g: 162, b: 137, a: 0 },
  { r: 230, g: 173, b: 106, a: 0 },
  { r: 169, g: 171, b: 174, a: 255 },
  { r: 219, g: 33, b: 38, a: 0 },
  { r: 76, g: 115, b: 161, a: 0 },
  { r: 255, g: 247, b: 254, a: 0 },

]

plotty.addColorScale("landcover",
  [
    '#FFFFFF',
    '#033e00',  // 1  Temperate or sub-polar needleleaf forest
    '#939b71',  // 2  Sub-polar taiga needleleaf forest
    '#196d12',  // 3  Tropical or sub-tropical broadleaf evergreen forest
    '#1fab01',  // 4  Tropical or sub-tropical broadleaf deciduous forest
    '#5b725c',  // 5  Temperate or sub-polar broadleaf deciduous forest
    '#6b7d2c',  // 6  Mixed forest
    '#b29d29',  // 7  Tropical or sub-tropical shrubland
    '#b48833',  // 8  Temperate or sub-polar shrubland
    '#e9da5d',  // 9  Tropical or sub-tropical grassland
    '#e0cd88',  // 10  Temperate or sub-polar grassland
    '#a07451',  // 11  Sub-polar or polar shrubland-lichen-moss
    '#bad292',  // 12  Sub-polar or polar grassland-lichen-moss
    '#3f8970',  // 13  Sub-polar or polar barren-lichen-moss
    '#6ca289',  // 14  Wetland
    '#e6ad6a',  // 15  Cropland
    '#a9abae',  // 16  Barren land
    '#db2126',  // 17  Urban and built-up
    '#4c73a1',  // 18  Water
    '#fff7fe',  // 19  Snow and ice
  ],
  [0, 0.05, 0.1, 0.15, 0.2, 0.25, 0.3, 0.35, 0.4, 0.45, 0.5, 0.55, 0.6,0.65, 0.7, 0.75, 0.8,  0.85, 0.9,  1]);


plotty.addColorScale("mycolorscale", ["#00ff00", "#0000ff", "#ff0000"], [0, 0.5, 1]);



const convertImageData = (raster, url) => {
  if (!raster) return null;
  let [r] = raster;
  let { width, height } = raster;


  const canvas = document.createElement("canvas");
  //const renderid = (Math.random() > 0.5) ? "prerender1" : "prerender2";
  //const canvas = document.getElementById(renderid);

  canvas.width = width;
  canvas.height = height;

  /*   GPU rendaring
  const plot = new plotty.plot({
    canvas: canvas,
    data: r, width: width, height: height,
    domain: [0, 20], colorScale: 'landcover'
  });
  plot.render();
  return canvas
  //*/

  
  const ctx = canvas.getContext("2d");
  const imageData = ctx.getImageData(0, 0, width, height);
  const data = imageData.data;

  for (let i = 0; i < r.length; i++) {
    const rs = r[i];  // some scaling
    const color = colorTable[rs]
    data[i * 4] = color.r;
    data[i * 4 + 1] = color.g;
    data[i * 4 + 2] = color.b;
    data[i * 4 + 3] = rs == 17? 255 : 0;
  }

  const img = new ImageData(data, width, height)

  ctx.putImageData(img, 0, 0);
  
  return canvas

}


export function renderLayers({ data }) {

  //OSMタイルを読み込みベースマップとして表示
  const cogLayer = new TileLayer({
    id: "cog-layer",
    data: GeotiffURL,
    minZoom: 6,
    maxZoom: 6,
    zoomOffset: 6,
    //maxCacheSize: 8,
    getTileData: async (e) => {
      const bbox = [e.bbox.west, e.bbox.south, e.bbox.east, e.bbox.north]
      const cog = await fromUrl(e.url)
      const aoiRaster = await cog.readRasters({
        bbox: bbox,
        resx: 1,
        resy: 1
      });
      const img = convertImageData(aoiRaster, e.url)
      return img
    },
    tileSize: 512,

    renderSubLayers: (props) => {
      const {
        bbox: { west, south, east, north }
      } = props.tile;

      return new BitmapLayer(props, {
        data: null,
        image: props.data,
        bounds: [west, south, east, north]
      });
    }
  });  

  //OSMタイルを読み込みベースマップとして表示
  const tileLayer = new TileLayer({
    id:"tile-layer",
//    data: "https://c.tile.openstreetmap.org/{z}/{x}/{y}.png",
    data: "https://api.maptiler.com/maps/backdrop/{z}/{x}/{y}.png?key=WnDavn9jMjHyl7zWOqRp",
    minZoom: 0,
    maxZoom: 19,
    tileSize: 256,

    renderSubLayers: (props) => {
      const {
        bbox: { west, south, east, north }
      } = props.tile;

      return new BitmapLayer(props, {
        data: null,
        image: props.data,
        bounds: [west, south, east, north]
      });
    }
  });  

  

  //レイヤーの重なり順を配列で指定(先頭のレイヤーが一番下になる)
  return [tileLayer, cogLayer];
}
